import React, { useState, useEffect } from 'react';
import { Layout, Menu, Tooltip, Popover, Avatar, Input, Button, Tag } from 'antd';
import { BrowserRouter as Router1, HashRouter as Router, Route, Link, Redirect, useHistory } from "react-router-dom";
import { DowntimeReasonGrid } from '@gtpl/pages/master/master-components/downtime-reason-grid';
import { DowntimeReasonForm } from '@gtpl/pages/master/master-components/downtime-reason-form';
import { DownTimeEventCalender, DownTimeTrackingGrid } from '@gtpl/pages/master/master-components/down-time-tracking-grid';
import { NewDowntimeTrackingform } from '@gtpl/pages/master/master-components/down-time-tracking-form';


export const DowntimeRouting = () =>{
    return(
        <>
 <Route exact path="/DownTimeReason-view" component={DowntimeReasonGrid} />
 <Route exact path="/DowntimeReason-form" render={props => <DowntimeReasonForm downtimereasonData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateItem={(undefined) => { }} />}
                    />
<Route exact path="/downtimetracking-view" component={DownTimeTrackingGrid} />
<Route exact path="/down-time-tracking-new-form" render={props => <NewDowntimeTrackingform downtimeTrackingData={undefined}
                        isUpdate={false}
                        closeForm={() => { }}
                        updateDetails={(undefined) => { }} />}
                    />
<Route exact path="/downtime-event-calender" component={DownTimeEventCalender} />


        </>

    )
}
export default DowntimeRouting